var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEasySearch = function SvgEasySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#F0EDED",
    rx: 32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#easy-search_svg__a)",
    rx: 32
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#easy-search_svg__b)",
    rx: 32
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#easy-search_svg__c)",
    fillOpacity: 0.63,
    rx: 32
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#fff",
    fillOpacity: 0.33,
    rx: 32
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#895FFC",
    rx: 32
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#easy-search_svg__d)",
    rx: 32
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#fff",
    fillOpacity: 0.65,
    rx: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.901 17a15.3 15.3 0 0 0-4.584 10.938c0 8.472 6.87 15.34 15.342 15.34q.426 0 .848-.023v3.34a3 3 0 0 1-3 3H17a3 3 0 0 1-3-3V20a3 3 0 0 1 3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.658 14.4c7.476 0 13.537 6.06 13.537 13.536l-.005.35a13.48 13.48 0 0 1-3.01 8.167l5.563 6.683a2 2 0 0 1-3.074 2.56l-5.442-6.537a13.47 13.47 0 0 1-7.569 2.315l-.349-.005c-7.314-.186-13.187-6.173-13.187-13.533 0-7.475 6.06-13.535 13.536-13.536m0 3c-5.819 0-10.536 4.718-10.536 10.537 0 5.818 4.717 10.536 10.536 10.537 5.82 0 10.537-4.718 10.537-10.537S41.477 17.4 35.658 17.4",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M35.848 19.484c3.851 0 6.17 2.575 5.778 6.099-.282 2.54-2.965 7.15-4.99 10.118a.95.95 0 0 1-1.576 0c-2.026-2.967-4.708-7.577-4.99-10.118-.391-3.523 1.926-6.098 5.778-6.099m0 2.881a2.257 2.257 0 1 0 0 4.514 2.257 2.257 0 0 0 0-4.514",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "easy-search_svg__a",
    x1: -61.464,
    x2: 212.244,
    y1: 32,
    y2: 31.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895FFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9E7AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "easy-search_svg__b",
    x1: 6.624,
    x2: 61.947,
    y1: 64,
    y2: 64.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#3682FA",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "easy-search_svg__c",
    x1: -15.203,
    x2: 106.834,
    y1: 31.886,
    y2: 31.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "easy-search_svg__d",
    x1: 0,
    x2: 64,
    y1: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })))));
};
export default SvgEasySearch;